import {Component, OnInit} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {AuthService} from '../../../../../../../chat-common/src/lib/services/auth.service';
import {NgIf} from '@angular/common';
import {environment} from '../../../../../environments/environment';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-subscription-details',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './subscription-details.component.html',
  styleUrl: './subscription-details.component.scss'
})
export class SubscriptionDetailsComponent implements OnInit{
  url: URL;
  protected iframeUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer, private authService: AuthService) {

  }

  async ngOnInit(): Promise<void> {
    const response = await firstValueFrom(this.authService.getAccessToken())
    this.url = new URL(environment.subscriptionManager);
    this.url.searchParams.set('accessCode', response.headers.get('x-access-code'));
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.url.toString());
    }
}
